import React, {useState} from 'react';
import {Button, Checkbox, Form, Input, Modal, Table, theme} from "antd";
import {ColumnsType} from "antd/es/table";
import {QueryKey, useQueryClient} from "@tanstack/react-query";

import {useCommonUseMutation, useCommonUseQuery} from "../../../../../Common/hooks/rest/ReacQueryHook";
import {procAdminService} from "../../../../../Common/util/ProcService";
import {TB_STORAGE_EX_FTP} from "./data/TB_STORAGE_EX_FTP";
import {EditOutlined} from "@ant-design/icons";

const StorageInfra: React.FC = () => {
    const { token: { colorBgContainer },} = theme.useToken();
    const queryClient = useQueryClient();
    const queryKey:QueryKey =   [`StorageFTP`];

    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;

    const mutateUpdate = useCommonUseMutation<any>(queryKey, queryClient
        , procAdminService);

    const { data, isFetching} = useCommonUseQuery<TB_STORAGE_EX_FTP[]>(
        queryKey,
        () =>procAdminService<TB_STORAGE_EX_FTP[]>("post", `${serviceCode}ADS22`, null));

    const [showConfirmBox, setShowConfirmBox] = useState<boolean>(false);
    const [showModal, setShowModal] = useState<boolean>(false);

    const [ftpKey, setFtpKey] = useState<string>('');
    const [host, setHost] = useState<string>('');
    const [charSet, setCharSet] = useState<string>('utf-8');
    const [port, setPort] = useState<number>(21);
    const [id, setId] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [isPassive, setIsPassive] = useState<string>('0');
    const [isSsh, setIsSsh] = useState<string>('0');
    const [defaultPath, setDefaultPath] = useState<string>('/');
    const [modifyMode, setModifyMode] = useState<boolean>(false);


    const onDelete = (record:TB_STORAGE_EX_FTP) => {

        Modal.confirm({
            title: `스토리지 인프라 설정을 삭제하시겠습니까?`,
            content: "주의 : 시스템에 영향이 미칠 수 있습니다.",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowConfirmBox(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADD01`, requestBody:record }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);
                    }).finally(() => {
                    });
            },
            onCancel() {
                setShowConfirmBox(false);
            },
        });

    };


    function onSaveFTP()
    {
        const request:TB_STORAGE_EX_FTP = {
            ftpKey:ftpKey,
            host:host,
            port:port,
            id:id,
            password:password,
            isPassive:isPassive,
            charSet:charSet,
            isSsh:isSsh,
            defaultPath:defaultPath,
        }

        Modal.confirm({
            title: `FTP정보를 저장하시겠습니까?`,
            content: "주의 : 시스템에 영향이 미칠 수 있습니다.",
            open: showConfirmBox,
            okText: "확인",
            cancelText: "취소",
            onOk() {
                setShowModal(false);
                const updateParam = { method: 'post', serviceCode: `${serviceCode}ADU07`, requestBody:request }
                return mutateUpdate.mutateAsync(updateParam)
                    .catch(error => {
                        console.error(error);

                    }).finally(() => {
                    });
            },
            onCancel() {
                setShowModal(false);
            },
        });
    }



    const onRegiModal= () => {
        setModifyMode(false);
        setFtpKey('');
        setHost('');
        setPort(21);
        setId('');
        setPassword('');
        setIsPassive('0');
        setIsSsh('0');
        setShowModal(true);
        setDefaultPath('/')
    }

    const onModifyModal= (record:TB_STORAGE_EX_FTP) => {
        setModifyMode(true);
        setFtpKey(record.ftpKey);
        setHost(record.host);
        setPort(record.port);
        setId(record.id);
        setPassword('');
        setIsPassive(record.isPassive);
        setIsSsh(record.isSsh);
        setCharSet(record.charSet);
        setShowModal(true);
        setDefaultPath(record.defaultPath);
    }


    const columns: ColumnsType<TB_STORAGE_EX_FTP> = [
        {
            title: 'FTP KEY',
            dataIndex: 'ftpKey',
            key: 'ftpKey',
            render: (id: number) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {id}
                </div>
            ,
        },

        {
            title: 'HOST',
            dataIndex: 'host',
            key: 'host',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>
            ,
        },
        {
            title: 'ID',
            dataIndex: 'id',
            key: 'id',
            render: (id: number) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {id}
                </div>
            ,
        },
        {
            title: '비밀번호',
            dataIndex: 'password',
            key: 'password',
            ellipsis:true,
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'left', justifyContent: 'left' }}>
                    {text}
                </div>
        },
        {
            title: 'CHAR-SET',
            dataIndex: 'charSet',
            key: 'charSet',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    {text}
                </div>
            ,
        },
        {
            title: 'Passive 접속여부',
            dataIndex: 'isPassive',
            key: 'isPassive',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                   <Checkbox checked={text === '1' ? true : false} />
                </div>
        },
        {
            title: 'SFTP 여부',
            dataIndex: 'isSsh',
            key: 'isSsh',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Checkbox checked={text === '1' ? true : false} />
                </div>
        },
        {
            title: '기본접속경로',
            dataIndex: 'defaultPath',
            key: 'defaultPath',
            render: (text: string) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'left', justifyContent: 'left' }}>
                    {text}
                </div>
        },
        {
            title: '',
            key: 'Active',
            dataIndex: 'Active',
            render: (text, record:TB_STORAGE_EX_FTP) =>
                <div style={{ paddingBottom: '9px', margin:'0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Button type="link" size="small" onClick={() => {onModifyModal(record)}}>수정</Button>
                    <Button type="link" size="small" onClick={() => {onDelete(record)}}>삭제</Button>
                </div>
            ,
        },

    ];



    const fields = [
        { name: ['ftpKey'], value: ftpKey },
        { name: ['host'], value: host },
        { name: ['port'], value: port },
        { name: ['id'], value: id },
        { name: ['charSet'], value: charSet },
        { name: ['password'], value: password },
        { name: ['isPassive'], value: isPassive },
        { name: ['isSsh'], value: isSsh },
        { name: ['defaultPath'], value: defaultPath },
    ];

    return (
        <>
        <nav style={{
            margin:'0px 0px 14px 0px',
            padding:'9px 8px 9px 0px',
            height: '50px',
            display:'flex',
            justifyContent: "space-between",
            alignItems:'center',
            borderRadius: "8px", // 라운드 처리 추가
            border: '1px solid #dadada',
            background: colorBgContainer,
        }}>
            <div style={{ display: "flex", alignItems: "center" }}>
                <div style={{
                    padding: '9px 5px',
                    display:'flex',
                }}>
                </div>
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
                <Button style={{marginRight:"10px"}} type={"primary"} onClick={onRegiModal}>FTP등록</Button>
            </div>
        </nav>
        <Table columns={columns}
               dataSource={data}
               rowKey="id"
               loading={isFetching}
        />

            <Modal
                open={showModal}
                title={"FTP등록"}
                onCancel={()=>{setShowModal(false)}}
                footer={[
                    <></>
                ]}
            >
                <Form
                    name="saveFTP"
                    fields={fields}
                    initialValues={{
                        remember: false,
                    }}
                    onFinish={onSaveFTP}
                >
                    <Form.Item
                        label={"FTP키"}
                        name="ftpKey"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        {modifyMode ?

                            <Input
                                readOnly
                                prefix={<EditOutlined className="site-form-item-icon" />}
                                placeholder="FTP키"
                                value={ftpKey}
                                onChange={(e)=> setFtpKey(e.target.value)}
                            />
                            :
                            <Input
                                prefix={<EditOutlined className="site-form-item-icon" />}
                                placeholder="FTP키"
                                value={ftpKey}
                                onChange={(e)=> setFtpKey(e.target.value)}
                            />
                        }

                    </Form.Item>
                    <Form.Item
                        label={"HOST"}
                        name="host"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="HOST"
                            value={host}
                            onChange={(e)=> setHost(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"PORT"}
                        name="port"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="PORT"
                            type="number"
                            value={port}
                            onChange={(e)=> setPort(parseInt(e.target.value))}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"CHAR-SET"}
                        name="charSet"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="CHAR-SET"
                            value={charSet}
                            onChange={(e)=> setCharSet(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"접속ID"}
                        name="id"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="접속ID"
                            value={id}
                            onChange={(e)=> setId(e.target.value)}
                        />
                    </Form.Item>

                    <Form.Item
                        label={"비밀번호"}
                        name="password"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="비밀번호"
                            type="password"
                            value={password}
                            onChange={(e)=> setPassword(e.target.value)}
                        />
                    </Form.Item>
                    <Form.Item
                        label={"패시브모드"}
                        name="isPassive"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Checkbox checked={isPassive === '1' ? true : false} onChange={(e) => {
                            setIsPassive(e.target.checked ? '1' : '0')
                        }}/>
                    </Form.Item>

                    <Form.Item
                        label={"SFTP여부"}
                        name="isSsh"
                        rules={[
                            {
                                required : false,
                            },
                        ]}
                    >
                        <Checkbox checked={isSsh === '1' ? true : false} onChange={(e) => {
                            setIsSsh(e.target.checked ? '1' : '0')
                        }}/>
                    </Form.Item>
                    <Form.Item
                        label={"기본접속경로"}
                        name="defaultPath"
                        rules={[
                            {
                                required : true,
                            },
                        ]}
                    >
                        <Input
                            prefix={<EditOutlined className="site-form-item-icon" />}
                            placeholder="기본접속경로"
                            value={defaultPath}
                            onChange={(e)=> setDefaultPath(e.target.value)}
                        />
                    </Form.Item>


                    <Form.Item>
                        <Button type="primary" htmlType="submit" className="login-form-button">
                            적용
                        </Button>
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
};

export default StorageInfra;
